import React from "react";

import { deepFindOfObj, deepSetInObj, deepClone } from "utils";
import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { ReactComponent as OpenedEyeIcon } from "assets/images/app_svg/opened_eye.svg";
import { ReactComponent as ClosedEyeIcon } from "assets/images/app_svg/closed_eye.svg";

function showHidePassword(props) {
  function toggleShowHide() {
    const passwordInput = deepFindOfObj(props.state, props.path);

    if (props.subProp)
      passwordInput[props.subProp].type =
        passwordInput[props.subProp].type === "password" ? "text" : "password";
    else
      passwordInput.type =
        passwordInput.type === "password" ? "text" : "password";

    props.setState(prevState => {
      const state = deepClone(prevState);

      if (props.innerState)
        deepSetInObj(state[props.innerState], passwordInput, props.path);
      else deepSetInObj(state, passwordInput, props.path);

      return state;
    });
  }

  return (
    <React.Fragment>
      <Tooltip
        {...(props.show
          ? { ...TOOLTIPS.login.passwordHide }
          : { ...TOOLTIPS.login.passwordShow })}
      >
        {props.switch ? (
          <span
            className={
              "pwd_field_eyeIcon " +
              (props.show ? "show_pswd" : "pwd_field_hide")
            }
            onClick={toggleShowHide}
          >
            {props.show ? <ClosedEyeIcon /> : <OpenedEyeIcon />}
          </span>
        ) : (
          <span
            className={props.show ? "pwd-hide" : "pwd-show"}
            onClick={toggleShowHide}
          >
            {props.show ? <ClosedEyeIcon /> : <OpenedEyeIcon />}
          </span>
        )}
      </Tooltip>
    </React.Fragment>
  );
}

export default showHidePassword;
